import { Flex, Text, Box, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faFile } from '@fortawesome/pro-regular-svg-icons';
import { Modal } from '@morressier/alembic';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';

interface AuthorCommentsModalProps {
  onClose: () => void;
  authorResponse?: string;
  authorAttachments?: Array<{
    name: string;
    url: string;
  }>;
  submissionContextId: string;
}

export const AuthorCommentsModal = ({
  onClose,
  authorResponse,
  authorAttachments = [],
  submissionContextId
}: AuthorCommentsModalProps) => {
  return (
    <Modal isOpen onClose={onClose} width="720px">
      <Flex
        padding={8}
        gap={6}
        flexDirection="column"
        maxHeight="80vh"
        overflow="auto"
      >
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faComment} />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Author's Response</Text>
          <Text>
            New comments from the author are ready for review, along with their
            revised manuscript.
          </Text>
        </Flex>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">Response to Review Comments</Text>
          <Text textStyle="textBody">{authorResponse}</Text>
        </Flex>

        {authorAttachments.length > 0 && (
          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingItem">Author Attachments</Text>
            <Flex flexDirection="column" gap={2}>
              {authorAttachments.map((attachment, index) => (
                <Flex justifyContent="space-between" key={index}>
                  <Flex gap={2} alignItems="center">
                    <FontAwesomeIcon icon={faFile} />
                    <Text textStyle="textBody">{attachment.name}</Text>
                    <FileViewerButtonText
                      file={attachment}
                      submissionContextId={submissionContextId}
                      textStyle="textBody"
                      flexShrink={0}
                    >
                      View
                    </FileViewerButtonText>{' '}
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Flex>
        )}

        <Flex justifyContent="flex-end">
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
